import React, { useEffect, forwardRef, useImperativeHandle } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useTimer } from 'hooks/useTimer';
import { OFFSET_COUNTDOWN_SECONDS } from 'utils/constants';

const CountdownTimer = forwardRef(({ quizDuration, timesUp }, ref) => {
  const { seconds, stopTimer, startTimer, restartTimer } = useTimer(quizDuration, timesUp);
  const controls = useAnimation();
  const strokeWidth = 6;
  const radius = 27;
  const circumference = Math.ceil(2 * Math.PI * radius);
  const emptyStrokeOpacity = 1;
  const emptyStrokeDashArray = 1;

  useEffect(() => {
    if (quizDuration) {
      startTimer();
      controls.start({
        strokeDashoffset: [0, circumference], // Animate from full circumference to empty
        transition: {
          duration: quizDuration - OFFSET_COUNTDOWN_SECONDS,
          ease: 'linear'
        }
      });
    }
  }, [quizDuration]);

  const stopTimerOnSteroids = () => {
    controls.stop();
    stopTimer();
  };

  const restartTimerOnSteroids = () => {
    restartTimer();
    controls.start({
      strokeDashoffset: [0, circumference], // Animate from full circumference to empty
      transition: {
        duration: quizDuration - OFFSET_COUNTDOWN_SECONDS,
        ease: 'linear'
      }
    });
  };

  useImperativeHandle(ref, () => ({
    stopTimerOnSteroids,
    timeSpent: quizDuration - seconds,
    restartTimerOnSteroids
  }));

  return (
    <div ref={ref} className='si-timer__ct'>
      <svg viewBox='0 0 100 100'>
        <circle
          cx='50'
          cy='50'
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={emptyStrokeDashArray}
          strokeOpacity={emptyStrokeOpacity}
          fill='#F5F5F5'
        />
        <motion.circle
          cx='50'
          cy='50'
          r={radius}
          className='si-timer__circle'
          strokeWidth={strokeWidth}
          fill='transparent'
          strokeDashoffset={circumference} // Start with full circumference
          strokeDasharray={circumference}
          animate={controls}
        />
      </svg>
      <div className='si-timer__num'> {JSON.stringify(seconds)?.padStart(2, 0)}</div>
    </div>
  );
});

export { CountdownTimer };
